import { Link } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import { useDocumentMeta } from "../hooks/useDocumentMeta";
import "./public/public-models.css";

/**
 * 404 explícito. Antes cualquier URL desconocida renderizaba la home sin
 * cambiar la barra de direcciones, lo que se percibía como un error de
 * navegación.
 */
export default function NotFound() {
    useDocumentMeta({ title: "Página no encontrada", noIndex: true });

    return (
        <PublicLayout>
            <div className="public-empty" style={{ padding: "90px 16px" }}>
                <i className="fa-solid fa-compass"></i>
                <h2>Página no encontrada</h2>
                <p>La dirección que buscas no existe o fue movida.</p>
                <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                    <Link to="/" className="public-btn public-btn-primary">
                        Volver al inicio
                    </Link>
                    <Link to="/modelos" className="public-btn public-btn-ghost">
                        Ver modelos
                    </Link>
                </div>
            </div>
        </PublicLayout>
    );
}
